import type { ComponentPropsWithoutRef } from "react";
import { Text } from "./Text";

/** Унифицированное многострочное текстовое поле с подписью. */
type TextareaProps = Omit<ComponentPropsWithoutRef<"textarea">, "onChange"> & {
	label?: string;
	bare?: boolean;
	onChange: (value: string) => void;
};

export const Textarea = ({
	label,
	bare = false,
	className = "",
	onChange,
	...props
}: TextareaProps) => {
	const textarea = (
		<textarea
			className={
				bare
					? className
					: `mt-1.5 min-h-20 w-full resize-y rounded-lg border border-border bg-surface px-3 py-2.5 text-base outline-none focus:border-accent ${className}`
			}
			onChange={(event) => onChange(event.target.value)}
			{...props}
		/>
	);

	if (bare) return textarea;
	return (
		<label className="block text-sm font-medium">
			{label && <Text as="span">{label}</Text>}
			{textarea}
		</label>
	);
};
